import { render, staticRenderFns } from "./albums.vue?vue&type=template&id=7adf0c9e&scoped=true&"
import script from "./albums.vue?vue&type=script&lang=js&"
export * from "./albums.vue?vue&type=script&lang=js&"
import style0 from "./albums.vue?vue&type=style&index=0&id=7adf0c9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adf0c9e",
  null
  
)

export default component.exports